<template>
  <div>
    <div class="scrollContainer">
      <!-- <div
        style="height: 80vh"
        color="transparent"
        height="100vh"
      > -->
      <v-row style="margin-top: 16px;" max-width="1236px" class=" mx-12" align="center" justify="center">
        <v-col style="margin: 0px !important;" class="ma-12" cols="12" md="5" lg="5" xl="5">
          <h1 class="black--text text-h4 text-lg-h3 mb-4">
            <b>Earn an income from the things you already own <h1 style="color: #B22AF0 !important;" class="black--text text-h4 text-lg-h3 mb-4"><b>stress free.</b></h1></b>
          </h1>
          <h1 class="black--text text-body-1 font-weight-light">
            <b>Strapp helps you easily and safely rent out your possessions to
              others in your community, stress-free! <br />
              Manage your listings, bookings, and payments with no hassle or
              stress.</b>
          </h1>
          <v-btn id="lender-landing-start-now" v-bind="size" elevation="6" class="lender-landing-start-now mt-12 appbutton mx-1 mt-1 white--text font-weight-medium btn-6"
            rounded @click="signupDialog = true" color="#B22AF0" z-index="12"
            :class="$vuetify.breakpoint.mdAndUp ? '' : 'mt-3'">
            Start now</v-btn>
        </v-col>
        <v-col class="center" cols="12" md="7" lg="7" xl="7" style="margin: 0px !important">
          <img style="width: 100%; box-shadow: none !important; margin-bottom: 24px;"
            class="rounded-lg  ml-n6 mt-0 elevation-6" :src="require('@/assets/ad/screens.png')" alt="" />
        </v-col>
      </v-row>
      <div style="margin-top: 36px" class="center">
        <h1 class="black--text text-h6 text-lg-h3 ">
          <b>Partnerships with industry leaders</b>
        </h1>
        <h1 class="black--text text-body-1 font-weight-light">
          <b>We work with the best.</b>
        </h1>
      </div>
      <v-row justify="center" style="padding: 8px; margin-bottom: 8px">
        <v-col class="center" cols="6" xs="6" sm="6" md="6" lg="2" xl="2">
          <v-img class=" pimg" :src="require('@/assets/partnerLogos/stitch.jpg')">
          </v-img>

        </v-col>

        <v-col class="center" cols="6" xs="6" sm="6" md="6" lg="2" xl="2">
          <v-img class=" pimg" :src="require('@/assets/partnerLogos/payfast.jpeg')">
          </v-img>

        </v-col>

        <v-col class="center" cols="6" xs="6" sm="6" md="6" lg="4" xl="4">
          <v-img class=" pimg" :src="require('@/assets/partnerLogos/genric.jpg')">
          </v-img>

        </v-col>
        <v-col class="center" cols="6" xs="6" sm="6" md="6" lg="2" xl="2">
          <v-img class=" pimg" :src="require('@/assets/partnerLogos/innovation.jpg')">
          </v-img>

        </v-col>
        <v-col class="center" cols="6" xs="6" sm="6" md="6" lg="2" xl="2">
          <v-img class=" pimg" :src="require('@/assets/partnerLogos/sab.jpg')">
          </v-img>

        </v-col>
      </v-row>
  <v-sheet color="#ffff">
      <div style="padding-bottom: -2px !important;" class="footer-bg"></div>
    </v-sheet>


         <v-sheet color="#F8B58E">
      <base-section-heading color="white--text secondary lighten-2" title="How it Works" />

      <cards></cards>
    </v-sheet>



    <v-sheet class="pb-n3" color="#F8B58E">
      <svg id="curveUpColor" class="mb-n2" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100"
        viewBox="0 0 100 100" preserveAspectRatio="none">
        <path d="M0 100 C 20 0 50 0 100 100 Z" />
      </svg>
    </v-sheet>

      <v-container style="max-width: 1179px" id="start" :style="$vuetify.breakpoint.smAndDown ? '' : 'margin-top: 0vh'">
        <v-row>
          <v-col style="padding: 24px !important;" id="tech" class="grid" cols="12" lg="6" xl="6" md="6" sm="12" xs="12">
            <div class="text-lg-h6 ">
              <div class="font-weight-thin center mt-16 mt-5">
                <h2>R1000s per month in extra cash!</h2>
              </div>
              <br />
              <p class="text-headline">
                Unlock R1000s of Rands per month by sharing what you own with
                others
                <span class="secondary--text"> in your community </span>
              </p>
            </div>
          </v-col>
          <v-col class="center" cols="12" lg="6" xl="6" md="6" sm="12" xs="12">
            <v-img :src="require('@/assets/ad/aya.png')" max-width="600px" width="100%"></v-img>
          </v-col>

          <!-- <v-col class="hidden-md-and-up" cols="12" lg="6">
            <v-img
              :src="require('@/assets/ad/aya.png')"
              max-height="900"
              class="rounded-lg elevation-6"
              max-width="600"
            ></v-img>
          </v-col> -->
        </v-row>
      </v-container>



      <v-dialog v-model="signupDialog" scrollable :overlay="false" max-width="568px" transition="dialog-transition">
        <SignupComponent :shouldRedirect="true" :addItem="false" @loggedIn="signupDialog = false" :fromPage="true"
          @changeDialog="
  signupDialog = false;
loginDialog = true;
          ">
          <v-icon @click="signupDialog = false" class="exit">mdi-close</v-icon>
        </SignupComponent>
      </v-dialog>

      <v-dialog v-model="loginDialog" scrollable :overlay="false" max-width="568px" transition="dialog-transition">
        <LoginComponent :shouldRedirect="true" :fromPage="true" :addItem="false" @loggedIn="loginDialog = false"
          @changeDialog="
  loginDialog = false;
signupDialog = true;
          " />
      </v-dialog>

      <!-- <v-col>
            <img
              width="275"
              class="rounded-lg hidden-sm-and-down ml-n6 mt-0 elevation-6"
              :src="require('@/assets/lifestyle/lifestyle (7).webp')"
              alt=""
            />
          </v-col>

          <v-col>
            <img
              width="275"
              style=""
              class="rounded-lg ml-n16 hidden-sm-and-down elevation-6"
              :src="require('@/assets/lifestyle/lifestyle (4).webp')"
              alt=""
            />
          </v-col>

          <v-col>
            <img
              width="275"
              class="hidden-lg-only hidden-md-only rounded-lg ml-n16 mt-16 mr-18 elevation-6"
              :src="require('@/assets/lifestyle/lifestyle (5).webp')"
              alt=""
            />
          </v-col> -->

      <!-- </div> -->



      <!-- <v-container
        style="max-width: 1179px"
        id="start"
        :style="$vuetify.breakpoint.smAndDown ? '' : 'margin-top: 20vh'"
      >
        <v-row>
          <v-col class="hidden-sm-and-down" cols="12" lg="6">
            <v-img
              :src="require('@/assets/ad/phone.png')"
              max-height="900"
              max-width="600"
            ></v-img>
          </v-col>

        </v-row>
      </v-container> -->


      <!-- <v-row>
        <v-col class="grid mt-12"
           cols="12"
            md="5"
            lg="5"
            xl="5"
            >
        <div>
        <h3>Benefits of becoming a strapp lender.</h3>
          <p>Earn up to R15000 a year listing a camera!</p>
          </div>
        </v-col>
        <v-col
           cols="12"
            md="7"
            lg="7"
            xl="7"
            >
          <v-list tag="ul">
            <template v-for="(item, index) in items">
              <v-list-item tag="li" :key="index">
               <v-icon color="accent" class="mt-n9 mr-3">{{ item.icon }}</v-icon> <p><span class="font-weight-bold"> {{ item.text }}</span><br> {{ item.subtext }}</p>
              </v-list-item>
            </template>
          </v-list>
        </v-col>
        </v-row> -->
      <!-- <customer-reviews></customer-reviews> -->
      <v-row class="center" style="background: linear-gradient(135deg, #e14360 0%, rgb(178 42 240) 100%);">
      <div style="margin-top: 36px" class="center">
        <h1 class="white--text text-h6 text-lg-h3 ">
          <b>What our Users say </b>
        </h1>
        <h1 style="text-align: center; width: 85%;" class="white--text text-body-1 font-weight-light">
          <b>Don't just take it from us, here is what our customers are saying!</b>
        </h1>
      </div>
      <v-container style="max-width: 1179px" class="py-4 py-lg-8">
        <v-row>
          <v-col style=" width: 100%; margin: 0px" class="grid" cols="12" md="8">
            <v-row style="width: 100%; margin: 0px">
             <v-col style="padding:16px; width: 100%; margin: 0px" class="grid" cols="12" >
            <v-card class="center" style="width: 100%; margin: 0px; height: 300px;">
             <v-responsive
                class="mx-auto shrink text-center"
              width="90%"

              >
                <v-avatar class="mb-6" size="80">
                  <base-img :src="require(`@/assets/lisa.jpg`)" />
                </v-avatar>
                <base-body
                  text="
                  'The Strapp platform is professionally & securely put together and super easy to use. My items were loaded quickly and I am really impressed with the service so far! Highly recommend.'
                 "
                  tag="em"
                  class="mb-6 mt-n1 black--text d-block"
                />



                <base-title
                  class="black--text "
                  title="- Lisa-Marie Cheketri"
                  space="0"
                />

                <!-- <base-subtitle :title="customer.role" /> -->
              </v-responsive>
              </v-card>
              </v-col>
            </v-row>
            <v-row style="width: 100%; margin: 0px;">
              <v-col style="padding:16px; width: 100%; margin: 0px" class="grid" cols="12" md="6">
          <v-card class="center" style="width: 100%; margin: 0px; height: 300px;">
             <v-responsive
                class="mx-auto shrink text-center"
                width="90%"


              >
                <v-avatar class="mb-6" size="80">
                  <base-img :src="require(`@/assets/fadeelah.jpg`)" />
                </v-avatar>
                <base-body
                  text="'Professional, easy, secure, and safe, the item was high quality and the process seamless.'"
                  tag="em"
                  class="mb-6 mt-n1 black--text d-block"
                />



                <base-title
                  class="black--text "
                  title="- Fadeelah Adams"
                  space="0"
                />

                <!-- <base-subtitle :title="customer.role" /> -->
              </v-responsive>
              </v-card>

              </v-col>
                 <v-col style="padding:16px; width: 100%; margin: 0px" class="grid" cols="12" md="6">
              <v-card class="center" style="width: 100%; margin: 0px; height: 300px;">
             <v-responsive
                class="mx-auto shrink text-center"
                width="90%"

              >
                <v-avatar class="mb-6" size="80">
                  <base-img :src="require(`@/assets/julie.jpg`)" />
                </v-avatar>
                <base-body
                  text="'Super concept and seamless  functionality! Highly recommended.'"
                  tag="em"
                  class="mb-6 mt-n1 black--text d-block"
                />



                <base-title
                  class="black--text "
                  title="- Julie Tobiansky"
                  space="0"
                />

                <!-- <base-subtitle :title="customer.role" /> -->
              </v-responsive>
              </v-card>
              </v-col>
            </v-row>
          </v-col>
           <v-col style="padding:16px; width: 100%; margin: 0px" class="grid" cols="12" md="4">
          <v-row style="width: 100%; margin: 0px;">
           <v-col style="padding:16px; width: 100%; margin: 0px" class="grid" cols="12" >
         <v-card class="center" style="width: 100%; margin: 0px; height: 632px;">
             <v-responsive
                class="mx-auto shrink text-center"
              width="90%"

              >
                <v-avatar class="mb-6" size="80">
                  <base-img :src="require(`@/assets/gino.png`)" />
                </v-avatar>
                <base-body
                  text=" 'It was my first time using Strapp to rent equipment and the entire process was super fun. Questions were quickly answered and once I returned the rented equipment I was refunded my deposit. It was smooth a smooth rental process. Def going to use Strapp to rent equipment again soon. Excellent customer service from Strapp.'"
                  tag="em"
                  class="mb-6 mt-n1 black--text d-block"
                />



                <base-title
                  class="black--text "
                  title="- Gino Martini"
                  space="0"
                />

                <!-- <base-subtitle :title="customer.role" /> -->
              </v-responsive>
              </v-card>
              </v-col>
              </v-row>
           </v-col>
        </v-row>
      </v-container>
      </v-row>

      <v-container style="max-width: 1179px" class="py-4 py-lg-8">
        <v-row>
          <v-col style="padding-left: 24px;" class="grid " cols="12" md="6">
            <div class=" text-lg-h6 ">
              <div class="font-weight-thin center mt-16 mt-2">
                <h1> Rent Safely and Securely </h1>
              </div>
              <br />
              <p class="text-subtitle-1">
                Safe, trusted transactions with others.
              <ul>
                <li> User Verification</li>
                <li> Centralised Payments</li>
                <li> Insurance coverage*</li>
                <li> Rating & Reviews</li>
                <li> Deposit handling</li>
              </ul>
              </p>
               <a class="mt-12 mb-12" style="    text-decoration: none !important;" @click="$router.push('/faq')" >  <v-btn id="lender-landing-learn-more" v-bind="size" elevation="6" class="lender-landing-learn-more appbutton mx-1 mt-1 white--text font-weight-medium btn-6"
            rounded color="#B22AF0" z-index="12"
            :class="$vuetify.breakpoint.mdAndUp ? '' : 'mt-3'">
            Learn More</v-btn></a>
            </div>
          </v-col>
          <v-col cols="12" class="center" md="6">
            <v-img :src="require('@/assets/ad/safe.png')"  max-width="300"></v-img>
          </v-col>
        </v-row>
      </v-container>

      <v-row class="grid">
        <v-card width="90vw" class="rounded-lg" style="background: linear-gradient(135deg, #e14360 0%, rgb(178 42 240) 100%);">
          <v-row class="text-center white--text">
             <v-col cols="12" md="6" lg="6" xl="6">
              <div class="grid">
                <v-img contain class="mt-12 mb-12"  style="object-fit: contain; vertical-align: bottom; max-width: 150px;"
                  :src="require('@/assets/partnerLogos/genric.webp')">
                </v-img>
              </div>
            </v-col>
            <v-col style="padding: 32px !important;" cols="12" md="6" lg="6" xl="6" class="grid">
              <div class="grid">
                <h1 >We'll have you covered</h1>
                <p class="mt-12">
                  We are well on our way to built-in insurance coverage on each item rented, you'll enjoy a
                  risk-free experience alongside that added income.
                </p>

                <p >
                  Our lender guarantee will insure items up to <b>R30 000</b> in
                  partnership with Genric insurance.
                </p>

              </div>
            </v-col>

          </v-row>
        </v-card>
      </v-row>

      <v-container style="max-width: 1179px" class="py-4 py-lg-8 mt-16">
        <v-row>
          <v-col class="grid center" cols="12" md="4" style="padding: 24px;">
            <div class=" text-lg-h6 ">
              <div class="font-weight-thin center ">
                <h1> Simple Pricing </h1>
              </div>
              <br />
              <p style="line-height: 22px; text-align: center;" class="text-subtitle-1">
              Start for free and list as many items as you want. Only pay per approved booking which means we only get paid when you do!
              </p>
            </div>
             <v-btn id="lender-landing-free-account" v-bind="size" elevation="6" class="lender-landing-free-account mt-12 appbutton mx-1 mt-1 white--text font-weight-medium btn-6"
            rounded @click="signupDialog = true" color="#B22AF0" z-index="12"
            :class="$vuetify.breakpoint.mdAndUp ? '' : 'mt-3'">
            Open a FREE account</v-btn>
          </v-col>
          <v-col style="padding: 32px !important;" cols="12" class="center" md="4">
                   <v-hover v-slot:default="{ hover }">
              <v-card
                class="card"
                style="padding: 16px; width: 100%; height: 450px;"
                shaped
                :elevation="hover ? 10 : 4"
                :class="{ up: hover }"
              >
              <div>
             <h4 style="line-height: 22px !important; color: #B22AF0; font-size: large !important;"  class="font-weight-regular subtitle-1">Free</h4>
             </div>
             <div>
             <h4 style="line-height: 22px !important; font-size: x-large !important;" class="font-weight-regular subtitle-1 mt-8"><b>R0</b> per listing</h4>
              </div>

              <div>
              <h4 style="line-height: 25px !important;" class="mt-8 font-weight-regular subtitle-1">
              <ul>
                <li>
 Free management dashboard

</li>
<li>
Unlimited listings
</li>
<li>
Payment Processing
</li>
<li>
Deposit handling
</li>
<li>
24/7 Support
</li>
<li>
Booking notifications
</li>

</ul>
                </h4>
                </div>
              </v-card>
            </v-hover>
          </v-col>

           <v-col style="padding: 32px !important;" cols="12" class="center" md="4">
                    <v-hover v-slot:default="{ hover }">
              <v-card
                class="card"
                style="padding: 16px; width: 100%; height: 450px;"
                shaped
                :elevation="hover ? 10 : 4"
                :class="{ up: hover }"
              >
              <div>
             <h4 style="line-height: 22px !important; color: #B22AF0; font-size: large !important;"  class="font-weight-regular subtitle-1">Service Fee</h4>
             </div>
             <div>
             <h4 style="line-height: 22px !important; font-size: x-large !important; margin-bottom: 8px !important;" class="font-weight-regular subtitle-1 mt-8"><b>15%</b> of rental value</h4>
                          <h4 style="line-height: 22px !important; font-size: x-large !important;" class="font-weight-regular subtitle-1 "><b>2.5%</b> of deposit value</h4>
              </div>

              <div>
              <h4 style="line-height: 25px !important;" class="mt-8 font-weight-regular subtitle-1">
              <ul>
                This covers:
                <li>
 Payment processing

</li>
<li>
User verification
</li>
<li>
Deposit handling
</li>
<li>
Notifications
</li>
<li>
Booking management software
</li>
<li>
Booking processing
</li>
<li>
Customer support
</li>


</ul>
                </h4>
                </div>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-container>


      <!-- <v-sheet class="pt-8 pt-lg-16">
        <div class="text-center">

          <h2 style="font-weight: 400 !important; color: rgb(34, 34, 34) !important" class="text-h4 text-lg-h4">
            <b>How it works</b>
          </h2>
        </div>
        <v-row :class="$vuetify.breakpoint.mdAndUp ? 'pl-16' : ''" class="mt-10" max-width="1250">
          <v-col cols="12" md="6" sm="12" xs="12" lg="5" offset-lg="1">
            <div class="pa-3" v-for="(item, i) in features" :key="i">
              <div class="d-flex">
                <div class="mr-2">
                  <v-sheet class="pa-2 mt-1">
                    <v-img :src="item.src"></v-img>
                  </v-sheet>
                </div>
                <div>
                  <div class="text-h6">{{ item.title }}</div>
                  <div class="text-subtitle-1 mt-1">
                    {{ item.description }}
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col :class="[$vuetify.breakpoint.mdAndUp ? '' : '']"
            :style="$vuetify.breakpoint.mdAndUp ? 'margin-top: 120px;' : ''" cols="12" md="6" sm="12" xs="12" lg="5">
            <div class="pa-3" v-for="(item, i) in features1" :key="i">
              <div class="d-flex">
                <div class="mr-2">
                  <v-sheet color="surface" rounded class="pa-2">
                    <v-img :src="item.src"></v-img>
                  </v-sheet>
                </div>
                <div>
                  <div class="text-h6">{{ item.title }}</div>
                  <div class="text-subtitle-1 mt-1">{{ item.description }}</div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <div class="font-weight-thin center mb-16 ">
          <h1 @click="$router.push('/faq')" style="cursor: pointer" class="text-subtitle-1 mt-1 secondary--text"> Check
            out our FAQ's to learn more </h1>
        </div>
      </v-sheet> -->



      <!-- <v-sheet class="grid" style="background: radial-gradient(circle, #b22af0 0%, #e69240 100%);" height="15vh">
        <h1 style="color: white">What our Users say</h1>
          <div class="text-h6" style="color: white">Don't just take it from us, here is what our customers are saying!</div>

      </v-sheet> -->

      <!-- <v-container class="py-4">
        <v-row>
          <v-col  class="grid" cols="12" md="6">
            <div class="mt-16 text-lg-h6 mt-5">
              <div class="font-weight-thin center mt-16 mt-5">
                <h1> Rent within your community </h1>
              </div>
              <br />
              <p class="text-subtitle-1">
             We are trying to bring back the spirit of ubuntu
              </p>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <v-img
              class="rounded-lg elevation-6"
              max-height="600"
              :src="require('@/assets/lifestyle/car.webp')"
            ></v-img>
          </v-col>
        </v-row>
      </v-container> -->



      <!-- <v-sheet>
        <v-container class="py-4 py-lg-8">
          <v-row>
            <v-col cols="12" md="4" xl="3">
              <h2 class="text-h6 text-lg-h6 mt-0 mt-xl-10">
                Experience more, for less
              </h2>
              <div class="text-headline text-lg-headline mt-5">
            Renting your beoongings that you only use every once in a while is a great way to start earning a passive income.
              </div>
              <div class="mt-4">
                <v-btn
                  large
                  class="my-1 mr-sm-1 w-full w-sm-auto"
                  color="secondary"
                  @click="GetStartedDialog = true"
                  >Order my cast</v-btn
                >
              </div>
            </v-col>
            <v-col cols="12" md="4" offset-xl="1">
              <v-img
                class="rounded-lg elevation-6"
                :src="require('@/assets/sporty.jpg')"
                :max-height="$vuetify.breakpoint.mdAndUp ? '700' : '300'"
                :min-height="$vuetify.breakpoint.mdAndUp ? '500' : '300'"
              ></v-img>
            </v-col>
            <v-col cols="12" md="4" xl="3" offset-xl="1">
              <div class="text-subtitle-1 mt-3 mt-xl-10">
                <div style="width: 80px; height: 4px" class="mb-5 secondary" />
                All side, no hustle 😏 the easiest and funnest way to make money
                <br /><br />
              </div>
              <div class="mt-4">
                <v-btn
                  large
                  class="my-1 mr-sm-1 w-full w-sm-auto"
                  color="secondary"
                  @click="physicianForm = true"
                  >Get Started</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet> -->
    </div>



    <!-- <v-row>
      <v-col class="text-center mb-12" id="Philosophy" cols="12" md="12">
        <base-section-heading
          color="primary--text secondary lighten-2"
          title="A cast that lets you
do it all "
        />

        <p class="subtitle-1">
          <strong> A cast should not restrict you.</strong>
        </p>
        <p class="subtitle-1">
          With our customized revolutionary cast design, the opportunities are
          simply endless. Our team is composed of surgeons, therapists, and
          clinicians who are fed up with using outdated methods and materials
          for our patients’ casts and splints.
        </p>
        <p class="subtitle-1">
          Free from the restrictions of standard casts, our sleek yet durable
          design is waterproof and breathable to ensure maximum comfort during
          the healing process. At Dimension Ortho, we will help you live life to
          the fullest despite your injury.
        </p>
      </v-col>
    </v-row> -->

    <v-sheet class="d-flex flex-column">
      <svg class="logos-bg" style="fill: #ffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1442 163">
        <path
          d="m-3.90909,6l48.30303,16c48.30303,16 144.90908,48 241.51514,48c96.60606,0 193.21211,-32 289.81817,-32c96.60606,0 193.21211,32 289.81817,53.3c96.60606,21.7 193.21211,31.7 289.81817,16c96.60606,-16.3 193.21211,-58.3 241.51514,-80l48.30303,-21.3l0,160l-48.30303,0c-48.30303,0 -144.90908,0 -241.51514,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -241.51514,0l-48.30303,0l0,-160z" />
      </svg>
    </v-sheet>
    <!--
    <v-sheet color="#f2f5f8">
      <base-section-heading
        color="primary--text secondary lighten-2"
        title="Quick and Easy"
        class="mb-n3"
      />
      <v-container>
        <v-row> </v-row>
      </v-container>
    </v-sheet> -->



    <!-- <v-sheet color="#F2F5F8">
      <base-section-heading
        class="text-h3"
        color="primary--text secondary lighten-2"
        title="Worried about the cost? "
      />

      <p class="text-body-1 text-center ml-9 pb-10">
        Don’t worry, we’ve got you covered. Our custom casts are covered by most
        insurance companies.
      </p>

      <div class="grid">
        <img :src="require('@/assets/svgs/meditate-1.svg')" />
      </div>
    </v-sheet> -->

    <!-- <v-sheet color="#F2F5F8" class="d-flex flex-column">
      <svg
        class="logos-bg"
        style="fill: #f8b58e"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1442 163"
      >
        <path
          d="m-3.90909,6l48.30303,16c48.30303,16 144.90908,48 241.51514,48c96.60606,0 193.21211,-32 289.81817,-32c96.60606,0 193.21211,32 289.81817,53.3c96.60606,21.7 193.21211,31.7 289.81817,16c96.60606,-16.3 193.21211,-58.3 241.51514,-80l48.30303,-21.3l0,160l-48.30303,0c-48.30303,0 -144.90908,0 -241.51514,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -241.51514,0l-48.30303,0l0,-160z"
        />
      </svg>
    </v-sheet> -->

    <!-- <v-sheet color="#F8B58E">
      <v-container class="py-4 py-lg-8">
        <div class="text-center">
          <div
            class="text-uppercase font-weight-bold body-2 primary--text mb-2"
          >
            TOP CLASS 3D-PRINTED CASTS
          </div>
          <h2 class="text-h4 text-lg-h4">REGISTER AS A NEW PATIENT TODAY</h2>
          <v-responsive max-width="1200" class="mx-auto">
            <div class="text-subtitle-1 text-lg-subtitle-1 mt-4 mb-4">
              All you need to do to get started is register your patient
              accoount on the form below and you will be in our system. From
              there will be granted access to your personalized Patient
              Dashboard and also place an order for a custom 3d-printed cast.
            </div>

            <v-row style="background-color: blue; height: 10"></v-row>
            <v-responsive>
              <v-divider
                color="secondary"
                align="center"
                class="ma-6 ml-auto mr-auto mb-10 font-weight-bold"
                width="200px"
              />
            </v-responsive>
          </v-responsive>
        </div>
        <v-row class="mt-2">
          <v-col cols="12" md="6">
            <div class="d-flex pa-2">
              <div class="pa-2">
                <v-sheet
                  color="blue"
                  class="pa-2"
                  style="border-radius: 30px; font-size: 20px"
                >
                  <v-icon style="color: white; font-size: 30px"
                    >mdi-account-check-outline</v-icon
                  >
                </v-sheet>
              </div>
              <div class="pa-2">
                <div class="text-h5 font-weight-light">
                  PERSONALIZED ACCOUNT
                </div>
                <div class="text-subtitle-1">
                  Once you sign up you will be granted access to your very own
                  patient dashboard from which you can take control of your
                  cast.
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="d-flex pa-2">
              <div class="pa-2">
                <v-sheet
                  color="blue"
                  class="pa-2"
                  style="border-radius: 30px; font-size: 20px"
                >
                  <v-icon style="color: white; font-size: 30px"
                    >mdi-lifebuoy</v-icon
                  >
                </v-sheet>
              </div>
              <div class="pa-2">
                <div class="font-weight-light text-h5">
                  PRIME PATIENT SUPPORT
                </div>
                <div class="text-subtitle-1">
                  Receive top-class support if you ever need it during your time
                  wearing Dimension Casts. Our support team are here for you
                  when you need it.
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="d-flex pa-2">
              <div class="pa-2">
                <v-sheet
                  color="blue"
                  class="pa-2"
                  style="border-radius: 30px; font-size: 20px"
                >
                  <v-icon style="color: white; font-size: 30px"
                    >mdi-email-open-multiple-outline</v-icon
                  >
                </v-sheet>
              </div>

              <div class="pa-2">
                <div class="text-h5 font-weight-light">FAST COMMUNICATION</div>
                <div class="text-subtitle-1">
                  Communicate with your physician in a streamlined manner using
                  your patient dashboard. Efficient communications allow for a
                  smooth and enjoyable patient experience.
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="d-flex pa-2">
              <div class="pa-2">
                <v-sheet
                  color="blue"
                  class="pa-2"
                  style="border-radius: 30px; font-size: 20px"
                >
                  <v-icon style="color: white; font-size: 30px"
                    >mdi-clock-outline</v-icon
                  >
                </v-sheet>
              </div>
              <div class="pa-2">
                <div class="text-h5 font-weight-light">
                  ENJOY TIME IN YOUR CAST
                </div>
                <div class="text-subtitle-1">
                  Gone are the days where you need to stock up on skewer sticks
                  to scratch your itch underneath that nasty old-school cast.
                  Actually enjoy wearing this futuristic 3D-printed cast while
                  you are forced to recover.
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet> -->
    <!-- <v-sheet>
      <svg
        class="separator"
        width="100%"
        height="120"
        viewBox="0.1 0.1 180 40"
        preserveAspectRatio="none"
      >
        <g transform="translate(-18.298844,-77.973964)">
          <path
            style="fill: #b22af0"
            d="M 31.615583,86.351641 H 192.16499 v 26.901969 c 0,0 -32.03411,-14.237983 -59.62682,-12.72484 -22.34188,1.2252 -54.779359,9.72634 -54.779359,9.72634 0,0 -22.029534,3.62882 -34.471238,-1.88988 -12.441702,-5.51871 -11.67199,-22.013589 -11.67199,-22.013589 z"
          />
          <path
            style="fill: #f8b58e"
            d="M 18.441597,78.106256 H 198.58126 v 39.288614 c 0,0 -43.10672,-27.825245 -73.47599,-19.687823 -30.369264,8.137423 -46.832208,12.548653 -46.832208,12.548653 0,0 -32.775418,8.05972 -46.735258,0 C 17.577964,102.19598 18.441597,78.106256 18.441597,78.106256 Z"
          />
        </g>
      </svg>
    </v-sheet>

    <PatientReviews /> -->
    <!--
    <v-sheet>
      <div class="d-flex flex-column flex-md-row">
      <faq></faq>
      </div>
    </v-sheet> -->
  </div>
</template>

<script>
import LoginComponent from '@/components/Auth/Login';
import SignupComponent from '@/components/Auth/Signup';

export default {
  name: 'StrappAd',

  data: () => ({
    loginDialog: false,
    signupDialog: false,
    selectedItem: 1,
    items: [
      {
        text: 'Be in control',
        subtext: 'Set your rates and control your rental schedule',
        icon: 'mdi-check',
      },
      {
        text: 'Earn money',
        subtext:
          'Earn extra cash to help pay off your stuff or fund your next adventure',
        icon: 'mdi-check',
      },
      {
        text: 'Join a passionate community',
        subtext: 'Our lender community offers advice for new owners',
        icon: 'mdi-check',
      },
      {
        text: 'Every item is covered',
        subtext:
          'Every rental is covered with up to R30 000 liability insurance',
        icon: 'mdi-check',
      },
      {
        text: 'Get paid quickly',
        subtext:
          'Money hits your bank account within 24 - 48 hours of trip departure',
        icon: 'mdi-check',
      },
      {
        text: 'Verified renters',
        subtext:
          'Our comprehensive borrower verification ensures your stuff is in good hands',
        icon: 'mdi-check',
      },
    ],
    features: [
      {
        src: require('@/assets/fontawesome/circle-1-light.svg'),
        title: 'Add your item, FREE',
        description:
          'Add as many rental listings as you want for FREE and manage them in your dashboard.',
      },
      {
        src: require('@/assets/fontawesome/circle-2-light.svg'),
        title: 'Approve booking requests',
        description:
          'You decide... Approve or decline a booking based on availability. ',
      },
    ],
    features1: [
      {
        src: require('@/assets/fontawesome/circle-3-light.svg'),
        title: 'Get Paid',
        description:
          'Once the person has collected the item, we pay you the total rental fee, simple... ',
      },
      {
        src: require('@/assets/fontawesome/circle-4-light.svg'),
        title: 'Rate & Review',
        description:
          "We'll keep you updated all the way up to the end. Make sure your item is all in order and leave a rating & review. ",
      },
    ],
  }),

  components: {
    Cards: () => import('@/components/cards'),
    Logos: () => import('@/components/logos'),
    Faq: () => import('@/components/faq'),
    LoginComponent,
    SignupComponent,
    CustomerReviews: () => import('@/components/CustomerReviews'),
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.btn-6 {
  background: rgb(247, 150, 192);
  background: radial-gradient(circle, #b22af0 0%, #6db2e3 100%);
  line-height: 42px;
  padding: 0;
  border: none;
}

.btn-6 span {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}

.btn-6:before,
.btn-6:after {
  position: absolute;
  content: '';
  height: 0%;
  width: 1px;
}

.btn-6:before {
  right: 0;
  top: 0;
  transition: all 500ms ease;
}

.btn-6:after {
  left: 0;
  bottom: 0;
  transition: all 500ms ease;
}

.center {
  display: grid;
  place-items: center;
}

.pimg {
  /* height: auto; */
  max-height: 100px !important;
  max-width: 100px;
}

.btn-6:hover {
  background: transparent;
  color: #76aef1;
  box-shadow: none;
}

.btn-6:hover:before {
  transition: all 500ms ease;
  height: 100%;
}

.btn-6:hover:after {
  transition: all 500ms ease;
  height: 100%;
}

.btn-6 span:before,
.btn-6 span:after {
  position: absolute;
  content: '';
  box-shadow: -1px -1px 20px 0px rgba(255, 255, 255, 1),
    -4px -4px 5px 0px rgba(255, 255, 255, 1),
    7px 7px 20px 0px rgba(0, 0, 0, 0.4), 4px 4px 5px 0px rgba(0, 0, 0, 0.3);
}

.btn-6 span:before {
  left: 0;
  top: 0;
  width: 0%;
  height: 0.5px;
  transition: all 500ms ease;
}

.btn-6 span:after {
  right: 0;
  bottom: 0;
  width: 0%;
  height: 0.5px;
  transition: all 500ms ease;
}

.btn-6 span:hover:before {
  width: 100%;
}

.btn-6 span:hover:after {
  width: 100%;
}

#curveUpColor path,
#curveDownColor path {
  fill: #ffff;
  stroke: #fff;
}

#bigHalfCircle path {
  fill: #ffff;
  stroke: #ffff;
}

.footer-bg {
  background-color: #f8b58e;

  position: relative;
  overflow: hidden;
  z-index: 1;

  height: 100px;
  clip-path: polygon(
    0% 65%,
    1% 64.95%,
    2% 64.8%,
    3% 64.6%,
    4% 64.3%,
    5% 63.9%,
    6% 63.45%,
    7% 62.9%,
    8% 62.25%,
    9% 61.55%,
    10% 60.8%,
    11% 59.95%,
    12% 59.05%,
    13% 58.1%,
    14% 57.1%,
    15% 56.05%,
    16% 55%,
    17% 53.9%,
    18% 52.8%,
    19% 51.65%,
    20% 50.5%,
    21% 49.35%,
    22% 48.2%,
    23% 47.05%,
    24% 45.9%,
    25% 44.8%,
    26% 43.75%,
    27% 42.75%,
    28% 41.75%,
    29% 40.8%,
    30% 39.9%,
    31% 39.1%,
    32% 38.35%,
    33% 37.65%,
    34% 37.05%,
    35% 36.5%,
    36% 36.05%,
    37% 35.65%,
    38% 35.35%,
    39% 35.15%,
    40% 35.05%,
    41% 35%,
    42% 35.05%,
    43% 35.2%,
    44% 35.45%,
    45% 35.75%,
    46% 36.15%,
    47% 36.65%,
    48% 37.2%,
    49% 37.85%,
    50% 38.55%,
    51% 39.35%,
    52% 40.2%,
    53% 41.1%,
    54% 42.05%,
    55% 43.05%,
    56% 44.1%,
    57% 45.15%,
    58% 46.3%,
    59% 47.4%,
    60% 48.55%,
    61% 49.7%,
    62% 50.85%,
    63% 52%,
    64% 53.15%,
    65% 54.25%,
    66% 55.35%,
    67% 56.4%,
    68% 57.45%,
    69% 58.4%,
    70% 59.35%,
    71% 60.2%,
    72% 61.05%,
    73% 61.8%,
    74% 62.45%,
    75% 63.05%,
    76% 63.6%,
    77% 64.05%,
    78% 64.4%,
    79% 64.7%,
    80% 64.85%,
    81% 65%,
    82% 65%,
    83% 64.9%,
    84% 64.75%,
    85% 64.5%,
    86% 64.2%,
    87% 63.75%,
    88% 63.25%,
    89% 62.7%,
    90% 62.05%,
    91% 61.3%,
    92% 60.5%,
    93% 59.65%,
    94% 58.75%,
    95% 57.8%,
    96% 56.8%,
    97% 55.75%,
    98% 54.65%,
    99% 53.55%,
    100% 52.4%,
    100% 100%,
    0% 100%
  );
}

.lender-landing-start-now {

}

.lender-landing-free-account{

}

.lender-landing-learn-more{
  
}
</style>
